// extracted by mini-css-extract-plugin
export default {"copyable":"text-copy_copyable__zSdN9"};